import React from 'react'
import { Table } from 'semantic-ui-react'
import { BORDER_STYLE } from './SortableOrdersTable'
import {
  SORT_ORDER_ID,
  SORT_CUSTOMER_NAME,
  SORT_ORDER_APPOINTMENT_DATETIME,
  SORT_CART_TOTAL,
  SORT_ORDER_TOTAL,
  SORT_ORDER_PAID,
  SORT_ORDER_STATUS,
  SORT_SHOP_NAME,
  SORT_ORDER_CREATED_AT
} from '../../constants/search_filters'

// TODO: to get around a CSS issue of the table border extending too far, the <Table> was
// given no border and then styling added to individual cells.  This should be refactored.
export default function OrdersTableHeader({isReconciliation, checklistItems, sortableHeaderCell}) {
  const headerData1 = [
    { attr: SORT_ORDER_ID, label: 'ID' },
    { attr: SORT_CUSTOMER_NAME, label: 'Customer' },
    { attr: SORT_ORDER_APPOINTMENT_DATETIME, label: 'Appt Time' }
  ]
  const headerData2 = [
    { attr: SORT_CART_TOTAL, label: 'Cart Price' },
    { attr: SORT_ORDER_TOTAL, label: 'Final Price' },
    { attr: SORT_ORDER_PAID, label: 'Already Paid' },
    { attr: SORT_ORDER_STATUS, label: 'Status' },
    { attr: SORT_SHOP_NAME, label: 'Shop' },
    { attr: SORT_ORDER_CREATED_AT, label: 'Created At', borderRight: BORDER_STYLE }
  ]
  return(
    <Table.Row>
      {headerData1.map((data, i) => sortableHeaderCell(data, i))}
      {checklistItems.map((item, i) => { return (
        <Table.HeaderCell
          key={`orders-table-header-checklist-${i}`}
          style={{borderTop: BORDER_STYLE}}
        >
          {item.label}
        </Table.HeaderCell>
      )})}
      {headerData2.map(data => sortableHeaderCell(data))}
    </Table.Row>
  )
}
